import { render, staticRenderFns } from "./agregarExpediente.vue?vue&type=template&id=6aa8540f&scoped=true"
import script from "./agregarExpediente.vue?vue&type=script&lang=js"
export * from "./agregarExpediente.vue?vue&type=script&lang=js"
import style0 from "./agregarExpediente.vue?vue&type=style&index=0&id=6aa8540f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8540f",
  null
  
)

export default component.exports